<template>
  <v-container
    class="text-center"
    fill-height
    style="height: calc(100vh - 58px);"
  >
    <v-row align="center">
      <v-col>
        <h1 class="display-3 indigo--text">Ошибка 404</h1>
        <p>Мы не можем найти нужную вам страницу</p>
        <v-btn
          :to="{name: 'home'}"
          text
        >
          На главную страницу
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>

<style scoped>

</style>
